import React, { Component, MouseEvent, TouchEvent } from 'react';
import { CellDataTypes, Cell as AbsCell } from '@cluster/web-components'
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../store/reducers/persistedReducer';
import { selectLayoutCellById, selectCellIsFavorite, selectChannelSettings, selectCellDecorators, selectLayoutIsStatic, selectLayoutType, selectCurrentChannel } from '../store/selectors';
import { doOpenModal } from '../store/actions/modal';
// import CellTags from './CellTags';
import CellMenu from './CellMenu';
import CSS from 'csstype'
import { doGetCellDetail } from '../store/actions/cells';
import { ModalType } from '../Modal/ModalTypes';
import { selectCellHasAlert } from '../store/selectors/alerts';
import firebase from '../lib/firebase';
import classnames from 'classnames'
import { doToggleFocusCell } from '../store/actions/channelLayout';
import { isNative } from '../utils/utils';
import styles from './Cell.module.scss'
declare module 'csstype' {
  interface Properties {
    msGridRow?: number;
    '-ms-grid-row'?: number;

    msGridRowSpan?: number;
    '-ms-grid-row-span'?: number;

    msGridColumn?: number;
    '-ms-grid-column'?: number;

    msGridColumnSpan?: number;
    '-ms-grid-column-span'?: number;
  }
}


// Cell Wrapper Component
class Cell extends Component<CellDataTypes.CellProps & PropsFromRedux> {
  handleClick = async (e: MouseEvent | TouchEvent) => {
    // Check if the click is prevented by the channel panning.
    if (!e.defaultPrevented) {
      let popupWindow: Window | null = null;

      // Check both modalType fields.
      // this.props.modalType is on the short view, while this.props.cellDetail?.modalType is on the detail view
      const modalType = this.props.modalType || this.props.cellDetail?.modalType

      if (typeof modalType === "undefined" || modalType === null) {
        return;
      }

      if (!isNative() && modalType === "webView") {
        // Immediately open window to avoid popup blockers.
        popupWindow = window.open("about:blank", '_blank');
      }

      // Get Cell Details
      await this.props.doGetCellDetail(this.props.id);
      const cellDetail = this.props.cellDetail;

      if (popupWindow !== null) {
        const webDetail = cellDetail as unknown as CellDataTypes.WebViewCellDetail;
        // Change the URL of the popped up window if available
        popupWindow.location.href = webDetail.modalDetail.url;
      }
      else if (modalType === "webView" && isNative()) {
        const webDetail = cellDetail as unknown as CellDataTypes.WebViewCellDetail;

        import('@capacitor/core').then(capacitor => {
          capacitor.Plugins.Browser.open({ url: webDetail.modalDetail.url})
        });
      }
      else if (cellDetail) {
        this.props.doOpenModal({type: ModalType.Chart, cellId: this.props.id});
      }

      // Firebase event
      // Makes the modal type first character uppercase to match iOS data.
      const translatedType = modalType.charAt(0).toUpperCase() + modalType.slice(1)
      firebase.analytics.logEvent("load_modal_content", {cell_id: this.props.id, modal_type: translatedType});
    }
  }

  // Catch the focus cell click and stop propogation so the modal doesn't open.
  focusCell = (e: React.MouseEvent | React.TouchEvent) => {
    if (!e.defaultPrevented) {
      this.props.doToggleFocusCell(this.props.id);
      e.stopPropagation();
    }
  }

  render() {

    let cellWrapperStyle: CSS.Properties = {
      msGridColumn: this.props.posCol,
      msGridColumnSpan: (['quad', 'wide'].includes(this.props.size) ? 2 : 1),
      gridColumn: this.props.posCol + " / " + (['quad', 'wide'].includes(this.props.size) ? 'span 2' : 'span 1'),
      msGridRow: this.props.posRow,
      msGridRowSpan: (['quad', 'tall'].includes(this.props.size) ? 2 : 1),
      gridRow: this.props.posRow + " / " + (['quad', 'tall'].includes(this.props.size) ? 'span 2' : 'span 1'),
    }

    const feedbackUrl = encodeURI("mailto:support@clusterx.com?&subject=ClusterX Feedback&body=Cell Id: " + this.props.id + "\r\nTitle: " + this.props.title + "\r\nLayout: " + this.props.layout + "\r\nChannel: " + this.props.currentChannel?.name + " (" + this.props.currentChannel?.id + ")\r\n\r\nMy Feedback:\r\n")


    return (
      <div className={classnames(styles.wrapper, {[styles.wrapper_infocus]: this.props.inFocus})} style={cellWrapperStyle}>
        <AbsCell {...this.props } handleClick={(e) => this.handleClick(e)} focusCell={(e) => this.focusCell(e)} />
        <CellMenu cellId={this.props.id} cellTitle={this.props.title} cellLayout={this.props.layout} isFavorite={this.props.isFavorite} disableRecluster={this.props.layoutIsStatic || this.props.layoutType === "columns"} />
        {/* { this.props.layoutIsStatic || this.props.layoutType === "columns" ? '' : <CellTags cellId={this.props.id} tags={this.props.tags} /> } */}
        <div className={styles.feedback} onClick={() => {return window.location.href=feedbackUrl}}>Feedback?</div>
      </div>
    )
  }
}

const mapState = (state: RootState, props: CellDataTypes.CellProps) => {
  const cell = selectLayoutCellById(state, props.id)!;
  const currentChannel = selectCurrentChannel(state);
  const channelSettings = selectChannelSettings(state, currentChannel?.id);

  const cellHasAlert = currentChannel?.id ? selectCellHasAlert(state, currentChannel.id, props.id) : false;

  const cellDecorators = selectCellDecorators(state, props.id);

  return {
    theme: state.system.theme,
    inFocus: state.channelLayout.focusedCell === props.id,
    showFamilyColors: channelSettings.showFamilyColors,
    isFavorite: selectCellIsFavorite(state, cell?.id??0),
    cellHasAlert,
    layoutIsStatic: selectLayoutIsStatic(state),
    layoutType: selectLayoutType(state),
    currentChannel: currentChannel,
    ...cellDecorators,
    ...cell
  }
}

const mapDispatch = {
  doOpenModal,
  doGetCellDetail,
  doToggleFocusCell,
}

const connector = connect(
  mapState,
  mapDispatch
)

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(Cell);

